<template>
  <div class="topbar">
    <logo></logo>

    <nav class="navbar navbar-custom">
      <ul class="nav navbar-nav">
        <li-title></li-title>
      </ul>

      <ul class="nav navbar-nav pull-right">
        <li-loader class="hidden-sm-down"></li-loader>
        <main-custom-top-bar></main-custom-top-bar>
        <li-account></li-account>
      </ul>
    </nav>
  </div>
</template>

<script>
  import Logo from './TopBar/Logo'
  import LiMail from './TopBar/Navigation/LiMail'
  import LiAccount from './TopBar/Navigation/LiAccount'
  import LiTitle from './TopBar/Navigation/LiTitle'
  import LiLoader from './TopBar/Navigation/LiLoader.vue'
  import MainCustomTopBar from '../../../../../src/components/Templates/MainCustomTopBar.vue'

  export default {
    name: 'main-top-bar',
    components: {
      MainCustomTopBar,
      LiLoader,
      LiTitle,
      LiAccount,
      LiMail,
      Logo
    }
  }
</script>



// WEBPACK FOOTER //
// MainTopBar.vue?2696f1db